import PropTypes from 'prop-types';
import Select from 'react-select';

const SelectField = ({
  input,
  disabled,
  label,
  labelRequired,
  placeholder,
  options,
  meta: { touched, error, warning, submitError },
  helpText,
  cssClass,
}) => {
  const { name, onBlur, onChange, value } = input;

  const selectOptions = Array.isArray(options) ? options : [];

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onChange(selectedOption.value);
    } else {
      onChange('');
    }
  };

  const selected = selectOptions.find((opt) => opt.value === value) || null;

  if (!error) {
    error = submitError;
  }

  return (
    <div className={`form-group select-max-width select${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      {label && (
        <label htmlFor={name}>
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </label>
      )}
      <Select
        value={selected}
        onChange={handleChange}
        onBlur={onBlur}
        options={selectOptions}
        placeholder={placeholder}
        isDisabled={disabled}
        className="react-select-container"
        classNamePrefix="react-select"
      />
      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </div>
  );
};

SelectField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
  options: PropTypes.array,
};

export default SelectField;
